import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import userAction from './actions/userAction';
import Attendance from './components/attendance';
import AttendanceIndividual from './components/attendanceIndividual';
import AttendanceAll from './components/attendanceAll';
import JourneyPlanner from './components/journeyPlanner';
import Report from './components/report';
import ReportDetail from './components/reportDetail';
import LeaveApp from './components/leaveApp';
import LeaveInfo from './components/leaveInfo';
import LeaveSummary from './components/leaveSummary';
import UserSetting from './setComponents/userSetting';
import ContractorSetting from './setComponents/contractorSetting';
import LeaveSetting from './setComponents/leaveSetting';
import UserLogin from './components/userLogin';
import ForgotPassword from './components/userComponents/forgotPassword';
import ResetPassword from './components/userComponents/resetPassword';
import ChangePassword from './components/userComponents/changePassword';
import Estate from './components/estate';
import Employee from './components/employee';
import Contractor from './components/contractor';
import ContractorDisplay from './components/contractorComponents/contractorDisplay';
import CondoDisplay from './components/condoComponents/condoDisplay';
import ContractorNewForm from './setComponents/contractorComponents/contractorNewForm';
import CondoNewForm from './setComponents/condoSetComponents/condoNewForm';
import CondoForm from './setComponents/condoSetComponents/condoForm';
import ContractorForm from './setComponents/contractorComponents/contractorForm';
import CheckListForm from './setComponents/condoSetComponents/checkListForm';
import PermissionSetting from './setComponents/permissionSetting';
import JourneySetting from './setComponents/journeySetting';
import ResetForgotPassword from './components/userComponents/resetForgotPassword';
import CheckPtsSetting from './setComponents/checkPtsSetting';
import AttendanceCheck from './components/attendanceCheck';
import LeaveApply from './components/leaveApply';
import ReportCreate from './components/reportCreate';
import TeamSetting from './setComponents/teamSetting';
import LeaveAtdApply from './components/leaveAtdApply';
import HolidaySetting from './setComponents/holidaySetting';
import Policy from './components/policy';
export default class App extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (sessionStorage.getItem('ui')) {
            userAction.isUserLogin();
        }
    }

    render() {
        return (
            <div>

                <Switch>
                    <Route exact path="/" component={UserLogin} />
                    <Route exact path="/forgotPassword" component={ForgotPassword} />
                    <Route path="/forgotPassword/:token" component={ResetForgotPassword} />
                    <Route path="/resetPassword/:token" component={ResetPassword} />
                    <Route exact path="/changePassword" component={ChangePassword} />
                    <Route exact path="/attendance" render={(props) => <Attendance {...props} />} />
                    <Route path="/attendance/:id" component={AttendanceCheck} />
                    <Route path="/staff/:id" component={AttendanceIndividual} />
                    <Route path="/policy" component={Policy}/>
                    <Route exact path="/staff" component={AttendanceAll} />
                    <Route exact path="/journeyPlanner" component={JourneyPlanner} />
                    <Route exact path="/estate" component={Estate} />
                    <Route path="/report/create" component={ReportCreate} />
                    <Route path="/report/:id" component={ReportDetail} />
                    <Route exact path="/report" component={Report} />
                    <Route exact path="/leave" component={LeaveApp} />
                    <Route path="/leaveInfo/:id" component={LeaveSummary} />
                    <Route exact path="/leaveInfo" component={LeaveInfo} />
                    <Route path="/leave/:staffId" component={LeaveApply} />
                    <Route exact path="/contractor" component={Contractor} />
                    <Route exact path="/contractor/:id" component={ContractorDisplay} />
                    <Route exact path="/contractorSet/:id" component={ContractorForm} />
                    <Route exact path="/newContractor" component={ContractorNewForm} />
                    <Route exact path="/condo/:id" component={CondoDisplay} />
                    <Route exact path="/condoSet/:id" component={CondoForm} />
                    <Route exact path="/newCondo" component={CondoNewForm} />
                    <Route exact path="/apply/leaveAtd" component={LeaveAtdApply} />
                    <Route exact path="/checkListSetting" component={CheckListForm} />
                    <Route exact path="/permissionSetting" component={PermissionSetting} />
                    <Route exact path="/holidaySetting" component={HolidaySetting} />
                    <Route path="/userSetting" component={UserSetting} />
                    <Route path="/contractorSetting" component={ContractorSetting} />
                    <Route path="/leaveSetting" component={LeaveSetting} />
                    <Route path="/journeySetting" component={JourneySetting} />
                    <Route path="/teamSetting" component={TeamSetting} />
                    <Route path="/checkPtsSetting" component={CheckPtsSetting} />
                    <Route path="/userProfile" component={Employee} />
                </Switch>
            </div>
        );
    }
};




// WEBPACK FOOTER //
// ./app/app.jsx